// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mainBlock-module--wrapper--1vXK0","itemWrapper":"mainBlock-module--itemWrapper--sOwOA","active":"mainBlock-module--active--1R4ER"};